import React, { useEffect, useState, useRef } from "react";
import { DistributionsIntroduction } from "../types";
import {getDistributionIntroduction,postDistributionRecommend} from "../../service";
import { useLoading } from "../../components/loading/LoadingProvider";
import { useHistory } from "react-router-dom";
import { useModal } from "../../components/modal";
import title from '../../images/fx-title.png';
import btn from '../../images/fx-page2-btn1.png';
import rules from '../../images/rules.png';
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import {userInfoAction} from "../../store/actions";
import useUserInfo from "../../routers/useUserInfo";

const classnames = require('classnames')

function DistributionDetail() {
    const [info, setInfo] = useState<DistributionsIntroduction>();
    const [selected, setSelected] = useState<number>(0);
    const [cover,setCover] = useState(false)
    const loading = useLoading()
    const modal = useModal()
    const userData = useUserInfo();
    const { push, goBack } = useHistory()
    const slick = useRef(null)

    const {getFieldDecorator, validateFields } = useForm<{
        name : string,
        phone : string,
        industry : string,
    }>();

    const handleSubmit = (e:React.FormEvent) => {
        e.preventDefault();
        validateFields().then(res => {
           if(userData){
               loading.showLoading()
               postDistributionRecommend({
                    customerId:userData.id,
                   name:res.name,
                   phone:res.phone,
                   industry:res.industry,
                   category:selected
               }).then(
                   res => {
                       loading.hideLoading()
                       if(res.code === 1){
                            push('/home/distribution/lists')
                       }else{
                           modal.show({
                               title:'提示',
                               content:res.msg,
                               showCancel:false,
                               success(){

                               }
                           })
                       }
                   }
               )
           }

        })
            .catch(e => console.error(e.message));
    }

    useEffect(() => {
        loading.showLoading()
        getDistributionIntroduction()
            .then(res => {
                // console.log(res.data)
                setInfo(res.data)
                loading.hideLoading()
            }).catch(e => {
            loading.hideLoading()
            modal.show({
                title:'错误提示',
                content:'无法获取数据',
                showCancel:false,
                success(){
                    goBack()
                }
            })
        })
    },[])

    const handleCancel = () => {
        setCover(false)
    }


    return <div className="Distribution distributionDetail">
        <img src={ title } alt="" className="title"/>

        <div className="box2">
            <img src={ rules } onClick={() => setCover(true)} className='rules-icon' alt=""/>
            <div className="wrapper">
                <p className="ctitle">可推荐课程</p>
                <p className="kc">{ info?.coursesInfo }</p>
                <p className="ctitle">推荐学员</p>

                <form onSubmit={handleSubmit}>

                    <div className="border-color">
                        {
                            getFieldDecorator('name',{
                                rules: [{required: true, message: '请输入姓名'}],
                            })(<Input label='姓名' type={'text'} placeholder='请输入姓名'
                                      extraClass={['no-border','fill-width']}
                                      clear/>)
                        }
                    </div>



                   <div className="border-color">
                       {
                           getFieldDecorator('phone',{
                               rules: [{required: true, message: '请输入电话'},{ pattern: /^(13|14|15|17|18|19)[0-9]{9}$/, message: '请输入正确电话号码' }],
                           })(<Input label='电话' type={'number'} placeholder='请输入电话'
                                     extraClass={['no-border','fill-width']}
                                     clear/>)
                       }
                   </div>

                    <div className="border-color">
                        {
                            getFieldDecorator('industry',{
                                rules: [{required: true, message: '请输入行业'}],
                            })(<Input label='行业' type={'text'} placeholder='请输入行业'
                                      extraClass={['no-border','fill-width']}
                                      clear/>)
                        }
                    </div>

                    {/*<div className="switch">*/}
                    {/*   <div className="border-color">*/}
                    {/*       <div className={ classnames("_item",{ active: selected === 0 }) } onClick={() => setSelected(0)}>*/}
                    {/*           <p>信息推荐</p>*/}
                    {/*       </div>*/}
                    {/*   </div>*/}
                    {/*    <div className="border-color">*/}
                    {/*        <div className={ classnames("_item",{ active: selected === 1 }) } onClick={() => setSelected(1)}>*/}
                    {/*            <p>全程跟进</p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {
                        userData &&  <button type={'submit'} className="common-btn submit">
                            <img src={ btn } alt=""/>
                        </button>
                    }

                </form>
            </div>
        </div>
        {
            cover &&  <div className="rules-cover">
                <div className="_box">
                    <p className="ctitle">活动规则</p>
                    <div className="content">
                        <div dangerouslySetInnerHTML={{ __html: info ? info.ruleContent : '' }}/>
                    </div>
                    <p className="iconfont" onClick={handleCancel}>&#xe611;</p>
                </div>
            </div>
        }

    </div>
}

export default DistributionDetail
